import React, { useState, createContext, useContext, useRef } from "react";

const searchContext = createContext();

export function useSearch() {
  return useContext(searchContext);
}

function useSearchProvider() {
  const icdContainerRef = useRef();

  const [ICDCode, setICDCode] = useState([]);
  const [diagnosis, setDiagnosis] = useState("");

  return {
    icdContainerRef,
    ICDCode,
    setICDCode,
    diagnosis,
    setDiagnosis,
  };
}

export function SearchProvider({ children }) {
  const search = useSearchProvider();
  return (
    <searchContext.Provider value={search}>{children}</searchContext.Provider>
  );
}
